import React from 'react';
import Navbar from './Navbar';

const Error = () => {
  console.log('inside error')
  return (
    <div style={{ height: '100vh' }}>
      <Navbar />
      <div className='errorClass'>
          <h2>The page you are looking for is currently unavailable.</h2>
            <p>We are sorry for the inconvenience, please try again later.</p>
        </div>

    </div>
  );
};

export default Error;
